const productionToken = 'metrics-1';
const othersToken = 'd3ed748f96d732b999da4680ec5f92e3';
const activeToken =
  window.location.hostname === 'mixpanel.com' ? productionToken : othersToken;

// mixpanel production everything token - metrics-1
mixpanel.init(activeToken, {
    autotrack: true,
    persistence: 'localStorage',
    track_links_timeout: 1200,
    upgrade: true,
    loaded: function() {
        if(window.gdprInit){
            window.gdprInit();
        } else {
            var gdprInterval = setInterval(function() {
                if(window.gdprInit){
                    window.gdprInit();
                    clearInterval(gdprInterval);
                }
            },200);
        }
    }
});


// Declare namespace before any js!  (very important)
window.mp = {};

// Declare any application globals
mp.globals = {
    debug: false,
    disable_tti: false,
    domain: 'https://mixpanel.com',
    img_abs_url: 'https://cdn.mxpnl.com/site_media/images',
    variants: []
};

mp.globals.user_id = 'None';


function getIsGDPRValue(callback) {
    var isGDPR = false;
    jQuery.ajax({
        url: "https://mixpanel.com/api/app/gdpr/",
        data: {  },
        type: "GET",
        async: true,
        beforeSend: function(xhr){
            xhr.setRequestHeader('Authorization', 'Bearer metrics-1');
        },
        success: function(data) {
            isGDPR = data.results.is_gdpr;
            if( isGDPR === false && typeof MktoForms2 !== 'undefined' ) {
                MktoForms2.whenReady(function (form) {
                    jQuery('label[for="Email_Opt_In__c"]').parents('.mktoFormRow').attr('style','display: none !important');
                });
            }
        }
    });

    return isGDPR;
}

mixpanel.init(activeToken, {
    persistence: 'localStorage',
    track_links_timeout: 1200,
    upgrade: true
}, 'blog');

getIsGDPRValue();